import { render, staticRenderFns } from "./ClientAddressFieldManualInput.vue?vue&type=template&id=780e17bb"
import script from "./ClientAddressFieldManualInput.vue?vue&type=script&lang=js"
export * from "./ClientAddressFieldManualInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports